import React from 'react';
// import propTypes from 'prop-types';

import { Accordion } from '@common/ui/general';
import { ProfilePicture, SocialProfile } from '@profile/ui/ProfileSidebar';

function ProfileInfo({ socialProfiles, userDetails }) {
  const {
    name, email, avatar, university, grad_year: gradYear, degree, field,
  } = userDetails;

  function titleUI() {
    return (
      <div className="row">
        <div className="column">
          <ProfilePicture avatar={avatar} />
        </div>
        <div className="profile-info__details-container">
          <h1 className="profile-info__name">
            {name}
          </h1>
          <p className="profile-info__email">
            {email}
          </p>
        </div>
      </div>
    );
  }

  function accordionTitleUI({ active, onClick }) {
    const handleClickEvent = (...params) => {
      window.trackGaEvent('Profile-Page', 'Profile-InfoClick', active);
      onClick(...params);
    };

    return (
      <div
        className="profile-info__header"
        onClick={handleClickEvent}
        role="presentation"
      >
        <span className="profile-info__header-title">
          Profile Info
        </span>
        <span className="profile-info__header-icon">
          { active ? '-' : '+' }
        </span>
      </div>
    );
  }

  function detailsUI(text, value) {
    return (
      <div className="row">
        <span className="profile-info__section-title">{text}</span>
        <span className="profile-info__section-text">
          {` ${value || 'N/A'}`}
        </span>
      </div>
    );
  }
  function accordionContentUI() {
    return (
      <div className="profile-info__content">
        <div className="profile-info__content-section">
          <div className="profile-info__section-header">
            Academic Info
          </div>
          {detailsUI('College', university)}
          {detailsUI('Degree', degree)}
          {detailsUI('Field', field)}
          {detailsUI('Grad Year', gradYear)}
        </div>
        <div className="profile-info__border" />
        <div className="profile-info__content-section">
          <div className="profile-info__section-header">
            Social Profiles
          </div>
          <SocialProfile profiles={socialProfiles} showHeader={false} />
        </div>
      </div>
    );
  }

  return (
    <div className="profile-info">
      {titleUI()}
      <Accordion title={accordionTitleUI}>
        {accordionContentUI()}
      </Accordion>
    </div>
  );
}

export default ProfileInfo;
